//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import ButtonRouter from '@/shared/components/ButtonRouter.vue';

export default {
  name: 'Workouts4_CTA',
  components: {
    ButtonRouter,
  },
  computed: {
    cta() {
      return { text: 'Shop Now', link: '/shop' };
    },
  },
};
